// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/bar
import { ResponsiveBar } from '@nivo/bar';
import { max, get } from 'lodash';

interface IDataItem {
  [key: string]: string | number;
}

const exampleData: IDataItem[] = [
  {
    monthLabel: 'Jan',
    count: 1707,
  },
  {
    monthLabel: 'Feb', // divider line
    count: 500,
  },
  {
    monthLabel: 'Mar',
    count: 510,
  },
  {
    monthLabel: 'Apr',
    count: 250,
  },
  {
    monthLabel: 'May',
    count: 520,
  },
];

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.

const xLabel = 'Month';
const yLabel = 'News Count';

const Barchart = ({
  data,
  keys,
  indexBy,
}: {
  data: IDataItem[];
  keys: string[];
  indexBy: string;
}) => {
  console.log(data, exampleData);
  // support multiple keys
  const maxArr = keys.map((k) => {
    return max((data || []).map((datum) => (get(datum, k) as number) || 0));
  });

  // overall keys acorss multiple keys
  const maxY = Math.max((max(maxArr) as number) || 9, 9);
  const pow = Math.ceil(Math.log10(maxY));
  // e.g. 1, 10, 100, 1000
  const step = Math.pow(10, pow - 1);
  // + 2 for extra top padding for barchart
  const ticks = Math.ceil(maxY / step) + 1;
  const maxOverall = step * ticks;
  const gridYValues = Array(ticks + 1)
    .fill(step)
    .map((s, i) => s * i);

  return (
    <ResponsiveBar
      data={data}
      keys={keys}
      indexBy={indexBy}
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={['#e6b12c']}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      maxValue={maxOverall}
      gridYValues={gridYValues}
      enableGridX={false}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: xLabel,
        legendPosition: 'middle',
        legendOffset: 32,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: yLabel,
        legendPosition: 'middle',
        legendOffset: -40,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      legends={[
        {
          dataFrom: 'keys',
          anchor: 'bottom-right',
          direction: 'column',
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: 'hover',
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      ariaLabel="News Barchart"
      barAriaLabel={(e) => `${e.id}: ${e.formattedValue} in month: ${e.indexValue}`}
    />
  );
};

export default Barchart;
